import OBase from './OBase';
import * as Geometry from '../geometry';
import * as GHMath from '../../math';
import { Voronoi, Node2d, Node2dList, Cell2d } from '@4kk11/geometry-tools';

export default class EPointArray extends OBase {
    update () {
        let innerPointsTree = this.getVector3Input('Points', false);
        let outerPointsTree = this.getVector3Input('Boundary', false);
        
        let inPtGraftTree = this.graft(innerPointsTree);
        
        let output = this.outputs["Cell"].paramObject;

        let dataTrees = [innerPointsTree, outerPointsTree];
        let outDataTrees = [];
        Geometry.makeMultipleBranches(dataTrees, outDataTrees);

        var outTree = new Geometry.DataTree();

        const innnerNodes = new Node2dList();
        const pointsBranch = outDataTrees[0].branches[0];
        for(let i=0; i<pointsBranch.length; i++){
            const x = pointsBranch[i].x;
            const y = pointsBranch[i].y;
            const node = new Node2d(x,y);
            innnerNodes.Append(node);
        }

        const outerNodes = new Node2dList();
        const boundsBranch = outDataTrees[1].branches[0];
        for(let i=0; i<boundsBranch.length; i++){
            const x = boundsBranch[i].x;
            const y = boundsBranch[i].y;
            const node = new Node2d(x,y);
            outerNodes.Append(node);
        }

        const cells = Voronoi.Solve(innnerNodes, outerNodes);

        for(let i=0; i<cells.length; i++)
        {
            const cell = cells[i];
            if(cell == null) continue;
            const nodes = cell.C;
            for(let j=0; j<nodes.length; j++)
            {
                const node = nodes[j];
                const newpt = new THREE.Vector3(node.x, node.y, 0);
                outTree.add(newpt, inPtGraftTree.paths[i])
            }
        }
        output.value = outTree;
    }

}


// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EVoronoi.js